import App from "./App";
import { Route, Routes as RouterDomRoutes, Navigate } from "react-router-dom";
import Login from "$components/Login";
import ProtectedRoute from "$api/ProtectedRoute";

export const Routes = () => {
  return (
    <RouterDomRoutes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<App />} />
      </Route>
    </RouterDomRoutes>
  );
};
